import React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import DescriptionIcon from '@mui/icons-material/Description';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import BadgeIcon from '@mui/icons-material/Badge';
import ExploreIcon from '@mui/icons-material/Explore';
import EngineeringIcon from '@mui/icons-material/Engineering';
import ManageHistoryIcon from '@mui/icons-material/ManageHistory';
import LockIcon from '@mui/icons-material/Lock'; // Import the lock icon
import Grid from "@mui/material/Grid";
import { useStyles } from "./styles";

const tabList = [
  { label: "Invoicing Overview", icon: <DescriptionIcon />, locked: false },
  { label: "Medical Reimbursement", icon: <MedicalServicesIcon />, locked: true },
  { label: "Employee Expense Reimbursement", icon: <BadgeIcon />, locked: false },
  { label: "Travel Expenses Reimbursement", icon: <ExploreIcon />, locked: true },
  { label: "Plant Maintenance Log", icon: <EngineeringIcon />, locked: true },
  { label: "Machine Downtime Log", icon: <ManageHistoryIcon />, locked: true },
];

const Homebar = ({ activeTab, handleTabChange }) => {
  const classes = useStyles();

  const handleChange = (event, newValue) => {
    const selectedTab = tabList[newValue];
    if (!selectedTab.locked) {
      handleTabChange(newValue);
    }
  };

  const handleLockedTabClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <Grid container className={classes.rootContainer}>
  <Grid item xs={11.5} container justifyContent="flex-start" flexWrap="wrap"> {/* Left-align the tabs container */}
    <Tabs
      value={activeTab}
      onChange={handleChange}
      variant="scrollable"
      sx={{
        '& .MuiTab-root': {
          color: '#354a5f',
          '&.Mui-selected': {
            color: '#fff',
            backgroundColor: '#354a5f',
          },
        },
        '& .MuiTabs-indicator': {
          backgroundColor: '#354a5f',
        },
      }}
    >
      {tabList.map((tab, index) => (
        <Tab
          key={index}
          disabled={tab.locked}
          onClick={tab.locked ? handleLockedTabClick : undefined}
          sx={{
            maxWidth: "100%",
            backgroundColor: activeTab === index ? '#354a5f' : 'transparent',
            color: activeTab === index ? '#fff' : '#354a5f',
            marginTop: activeTab === index ? '0' : '8px',
            borderTopLeftRadius: '10px',
            borderTopRightRadius: '10px',
            border: '1px solid #354a5f',
            '& .MuiSvgIcon-root': {
              color: activeTab === index ? '#fff' : '#354a5f',
            },
            '&:first-of-type': {
              borderTopLeftRadius: '8px',
              borderBottomLeftRadius: '0',
            },
            '&:last-of-type': {
              borderTopRightRadius: activeTab === tabList.length - 1 ? '8px' : '8px',
              borderBottomRightRadius: activeTab === tabList.length - 1 ? '0' : '0',
            },
            '&:hover': {
              backgroundColor: activeTab === index ? '#354a5f' : 'rgba(53, 74, 95, 0.1)',
            },
            position: "relative",
          }}
          label={
            <div style={{
              display: 'flex',
              alignItems: 'center',
              fontFamily: "SapFiori72, sans-serif",
              textTransform: "none",
              color: activeTab === index ? '#fff' : '#354a5f',
            }}>
              {tab.icon}
              <span style={{ marginLeft: "0.2rem", marginRight: "0.2rem" }}>{tab.label}</span>
              {tab.locked && (
                <LockIcon sx={{ position: "absolute", right: 4, top: "50%", transform: "translateY(-50%)", fontSize: "small" }} />
              )}
            </div>
          }
        />
      ))}
    </Tabs>
  </Grid>
</Grid>

  );
};

export default Homebar;
